export const CreatedByOptionsEnum = {
  THM: 'tryhackme',
  ME: 'me',
  TEAM: 'team',
  ALL: 'all',
} as const;

export const ProfileOptionsEnum = {
  THM: 'tryhackme',
  ME: 'me',
  TEAM: 'team',
} as const;

export type Profile = (typeof ProfileOptionsEnum)[keyof typeof ProfileOptionsEnum];

export type CreatedBy = (typeof CreatedByOptionsEnum)[keyof typeof CreatedByOptionsEnum];

export interface SearchContainerParams {
  createdBy: CreatedBy;
  search?: string;
  page: number;
  limit?: number;
}
